<div class="row">
  <div class="col-sm">
    <button class="btn btn-primary btn-round" (click)="back()"><i class="fas fa fa-long-arrow-alt-left"></i> Back</button>
  </div>
</div>
